export type PropertyStatus = 'live' | 'launching_soon' | 'fully_funded'

export const PROPERTY_STATUS = {
  LIVE: 'live',
  LAUNCHING_SOON: 'launching_soon',
  FULLY_FUNDED: 'fully_funded',
} as const satisfies Record<string, PropertyStatus>

export const PROPERTY_STATUSES: { key: PropertyStatus; label: string }[] = [
  { key: PROPERTY_STATUS.LIVE, label: 'Live' },
  { key: PROPERTY_STATUS.LAUNCHING_SOON, label: 'Launching Soon' },
  { key: PROPERTY_STATUS.FULLY_FUNDED, label: 'Fully Funded' },
]
